const NEWBEC_DEVICE_TYPE_MAP = {
  phone: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

/**
 * @deprecated
 * Нужно заменить на getAnalyticsSiteType
 */
export function getClientDeviceType() {
  if (typeof window !== 'undefined' && window.addformDeviceType) {
    return NEWBEC_DEVICE_TYPE_MAP[window.addformDeviceType];
  }

  return 'desktop';
}
